'use client';

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Link from 'next/link';

import { fetchJson } from 'lib/fetch-json';
import { EMAIL_REGEX } from 'lib/constants';

import { useTranslation } from 'src/i18n/client';
import Button from 'src/components/Button';
import Alert from 'src/components/Alert';
import FormError from 'src/components/FormError';
import { myAccountUrl } from 'src/services/route-utils';

export default function PageForm({ locale }: any) {
    const { t } = useTranslation(locale, 'common');
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState<string>();
    const [errorMsg, setErrorMsg] = useState<string>();
    const {
        register,
        formState: { errors: _errors },
        handleSubmit,
    } = useForm();

    const errors: any = _errors;

    const onSubmit = async (data: any) => {
        const body = { email: data.email };
        setLoading(true);

        try {
            await fetchJson(`/json/recover-password?locale=${locale}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            setErrorMsg('');
            setEmailSent(data.email);
        } catch (error: any) {
            setErrorMsg(error.data?.error?.message || t('unexpectedError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mx-auto text-center md:w-4/5 xl:w-2/3">
            <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
                <h1 className="text-5xl lg:text-6xl">{t('recover.heading')}</h1>

                <p className="my-4">{t('recover.description')}</p>

                {emailSent ? (
                    <Alert type="success">{t('recover.emailSent', { emailSent })}</Alert>
                ) : (
                    <>
                        <div>
                            <input
                                id="email"
                                type="email"
                                autoFocus
                                disabled={loading}
                                className={errors.email ? 'form-error' : ''}
                                placeholder={t('login.emailPlaceholder')}
                                {...register('email', {
                                    required: t('login.emailRequired'),
                                    pattern: {
                                        value: EMAIL_REGEX,
                                        message: t('login.emailInvalid'),
                                    },
                                })}
                            />
                            <FormError error={errors.email} />
                        </div>

                        <Button variant="primary" type="submit" disabled={loading} loading={loading}>
                            {t('recover.button')}
                        </Button>

                        <Link href={myAccountUrl('/login')} className="btn btn-default btn-sm">
                            {t('login.button')}
                        </Link>
                    </>
                )}

                {errorMsg && <Alert type="danger">{errorMsg}</Alert>}
            </form>
        </div>
    );
}
